import { useState } from 'react';
import { Settings, RefreshCw } from 'lucide-react';
import { Card } from './Card';
import { Button } from './Button';
import { Input } from './Input';
import { DEFAULT_SERVER_URL } from '../lib/api';

interface Config {
  url: string;
  key: string;
}

interface ConfigPanelProps {
  config: Config;
  setConfig: (config: Config) => void;
  onConnect: (config: Config) => void;
  loading: boolean;
}

export const ConfigPanel = ({ config, setConfig, onConnect, loading }: ConfigPanelProps) => {
  const [localConfig, setLocalConfig] = useState(config);

  return (
    <Card title="Server Configuration" icon={Settings}>
      <div className="space-y-3">
        <Input
          label="Server URL"
          placeholder={DEFAULT_SERVER_URL}
          value={localConfig.url}
          onChange={e => setLocalConfig({ ...localConfig, url: e.target.value })}
        />
        <Input
          label="API Key"
          type="password"
          placeholder="Your API key"
          value={localConfig.key}
          onChange={e => setLocalConfig({ ...localConfig, key: e.target.value })}
        />
        <Button
          onClick={() => { setConfig(localConfig); onConnect(localConfig); }}
          className="w-full justify-center"
          disabled={loading}
        >
          {loading ? <><RefreshCw size={16} className="animate-spin" /> Connecting...</> : 'Connect to Server'}
        </Button>
      </div>
    </Card>
  );
};
